import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatRippleModule } from '@angular/material/core';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { RouterModule } from '@angular/router';

import { NgSelectModule } from '@ng-select/ng-select';

import { MgEmptyStateModule } from '@app/src/app/components/EmptyState';
import { MgAvatarModule } from '@app/src/app/elements/MgAvatar';
import { MgIconModule } from '@app/src/app/icon';
import { MgPipesModule } from '@app/src/app/pipes';
import { SortArrowModule } from '@app/src/app/shared/components/sort-arrow';
import { TooltipModule } from '@app/src/app/shared/components/tooltip';
import { MgSpinnerModule } from '@app/src/app/spinner';

import { HpmDashboardPipesModule } from '@modules/hallpass-manager/components/hpm-dashboard/pipes/hpm-dashboard-pipes.module';
import { PeopleUserListEditModule } from '@modules/people/components/people-userlists/component/people-userslists-edit/people-userlists-edit.module';
import {
  PeopleUserListsActionService,
  PeopleUserListsPageStore,
} from '@modules/people/components/people-userlists/services';
import { SaSharedModule } from '@modules/selection-assigner/components/sa-shared/sa-shared.module';

import { CollapsibleModule } from '@shared/components/collapsible';
import { FormModule } from '@shared/components/form';
import { GenericModule } from '@shared/components/generic';
import { LayoutHeaderModule } from '@shared/components/layout-header';
import { SystemAlertModule } from '@shared/components/system-alert';
import { TextModule } from '@shared/components/text';
import { UserListFilterModule } from '@shared/components/user-list-filter/user-list-filter.module';
import { StudentPictureModule } from '@shared/directives/student-picture/student-picture.module';
import { CommonUIModules } from '@shared/modules';
import { ArrayPipesModule } from '@shared/pipes';
import { SlugifyPipeModule } from '@shared/pipes/slugify/slugify-pipe.module';
import { HallPassService } from '@shared/services/hall-pass';

import { TtAssignmentFooterComponent } from './components/tt-assignment-footer/tt-assignment-footer.component';
import { TtBehaviorFieldsComponent } from './components/tt-behavior-fields/tt-behavior-fields.component';
import { TtCheckInFieldsComponent } from './components/tt-check-in-fields/tt-check-in-fields.component';
import { TtConsequenceFieldsComponent } from './components/tt-consequence-fields/tt-consequence-fields.component';
import { TtDropdownButtonComponent } from './components/tt-dropdown-btn/tt-dropdown-btn.component';
import { TtFiltersComponent } from './components/tt-filters/tt-filters.component';
import { TtHallpassFieldsComponent } from './components/tt-hallpass-fields/tt-hallpass-fields.component';
import { TtPillComponent } from './components/tt-pill/tt-pill.component';
import { TtSettingsComponent } from './components/tt-settings/tt-settings.component';
import { TtSidebarComponent } from './components/tt-sidebar/tt-sidebar.component';
import { TtStudentCardComponent } from './components/tt-student-card/tt-student-card.component';
import { TtStudentListItemComponent } from './components/tt-student-list-item/tt-student-list-item.component';
import { AreActionsAssignedPipe } from './pipes/are-actions-assigned-pipe';
import { ShowCheckInsPipe } from './pipes/show-check-ins.pipe';
import { StudentSortPipe } from './pipes/student-sort-pipe';
import { TtMyClassComponent } from './tt-my-class.component';

@NgModule({
  imports: [
    // Common modules,
    CommonUIModules,

    CommonModule,
    SystemAlertModule,
    TextModule,
    NgSelectModule,
    MgIconModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    FormModule,
    SaSharedModule,
    GenericModule,
    MgEmptyStateModule,
    MgSpinnerModule,
    CollapsibleModule,
    ArrayPipesModule,
    MatMenuModule,
    MgAvatarModule,
    RouterModule,
    MatRippleModule,
    MatTooltipModule,
    HpmDashboardPipesModule,
    LayoutHeaderModule,
    PeopleUserListEditModule,
    SlugifyPipeModule,
    UserListFilterModule,
    StudentPictureModule,
    MgPipesModule,
    TooltipModule,
    SortArrowModule,
  ],
  declarations: [
    TtMyClassComponent,
    TtHallpassFieldsComponent,
    TtBehaviorFieldsComponent,
    TtConsequenceFieldsComponent,
    TtCheckInFieldsComponent,
    TtStudentCardComponent,
    TtPillComponent,
    TtSidebarComponent,
    StudentSortPipe,
    AreActionsAssignedPipe,
    TtAssignmentFooterComponent,
    TtStudentListItemComponent,
    TtFiltersComponent,
    TtSettingsComponent,
    TtDropdownButtonComponent,
    ShowCheckInsPipe,
  ],
  exports: [],
  providers: [HallPassService, PeopleUserListsPageStore, PeopleUserListsActionService],
})
export class TtMyClassModule {}
